import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import type {
  EventqShortcutAction,
  EventqShortcutKeymap,
  EventqShortcutKeymapStore,
  ProvideEventqShortcutsOptions,
} from './shortcut.models';
import { EventqShortcutService } from './shortcut.service';

export const EVENTQ_SHORTCUT_ACTIONS = new InjectionToken<readonly EventqShortcutAction[]>(
  'EVENTQ_SHORTCUT_ACTIONS',
);

export const EVENTQ_SHORTCUT_DEFAULT_KEYMAP = new InjectionToken<EventqShortcutKeymap>(
  'EVENTQ_SHORTCUT_DEFAULT_KEYMAP',
);

export const EVENTQ_SHORTCUT_KEYMAP_STORE = new InjectionToken<EventqShortcutKeymapStore>(
  'EVENTQ_SHORTCUT_KEYMAP_STORE',
);

export function provideEventqShortcuts(
  options: ProvideEventqShortcutsOptions,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: EVENTQ_SHORTCUT_ACTIONS, useValue: options.actions },
    { provide: EVENTQ_SHORTCUT_DEFAULT_KEYMAP, useValue: options.defaults },
    ...(options.store
      ? [{ provide: EVENTQ_SHORTCUT_KEYMAP_STORE, useValue: options.store }]
      : []),
    EventqShortcutService,
  ]);
}
